import { createSlice } from '@reduxjs/toolkit'
import { getBackgrounds, uploadBackground, deleteBackground  , getDefaultBackgrounds, uploadDefaultBackground, deleteDefaultBackground} from './settingsThunks'
import { getStoredDevice } from '../../../../utils/browserUtils.js';

const initialState = {
  activeTab: "audio", // "audio" or "video"
      // Internal settings dialog states device states
  selectedSettingsMic: getStoredDevice("selectedMic"), // Device object

  selectedSettingsSpeaker: getStoredDevice("selectedSpeaker"), //  Device object or null

  selectedSettingsCamera: getStoredDevice("selectedCamera"), // Device object or null
  
  // Camera effect state
  selectedSettingsEffect: "none",
  selectedSettingsBackground: "",
  defaultBackgrounds: [],
  customBackgrounds: [],
  publicDefaultBackgrounds: [
    "room.jpg",
    "room2.jpg",
    "room3.jpg",
    "room4.jpg",
    "room5.jpg",
    "room6.jpg",
    "room7.jpg"

],

}

const settingsSlice = createSlice({
  name: 'settingsModal',
  initialState,
  reducers: {
    initialiseDeviceSettings: (state, action) => {
      state.selectedSettingsEffect = action.payload.selectedEffect
      state.selectedSettingsBackground = action.payload.selectedBackground
    },
    setSettingsMic: (state, action) => {
      state.selectedSettingsMic = action.payload
    },
    setSettingsSpeaker: (state, action) => {
      state.selectedSettingsSpeaker = action.payload
    },
    setSettingsCamera: (state, action) => {
      state.selectedSettingsCamera = action.payload
    },
    setSettingsEffect: (state, action) => {
      state.selectedSettingsEffect = action.payload
    },
    setSettingsBackground: (state, action) => {
      state.selectedSettingsBackground = action.payload
    },
    setDefaultBackgrounds: (state, action) => {
      state.defaultBackgrounds = action.payload
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBackgrounds.fulfilled, (state, action) => {
        state.customBackgrounds = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(uploadBackground.fulfilled, (state, action) => {
        state.customBackgrounds.push(action.payload.data)
      })
      .addCase(getDefaultBackgrounds.fulfilled, (state, action) => {
        state.defaultBackgrounds = action.payload
      })
      .addCase(uploadDefaultBackground.fulfilled, (state, action) => {
        state.defaultBackgrounds.push(action.payload.data)
      })
      .addCase(deleteBackground.fulfilled, (state, action) => {
        const backgroundId = action.meta.arg.params[0]?.id;
        if (backgroundId) {
          state.customBackgrounds = state.customBackgrounds.filter(bg => bg.id !== parseInt(backgroundId));
        }
      })
      .addCase(deleteDefaultBackground.fulfilled, (state, action) => {
        const backgroundId = action.meta.arg.params[0]?.id;
        if (backgroundId) {
          state.defaultBackgrounds = state.defaultBackgrounds.filter(
            bg => bg.id !== parseInt(backgroundId)
          );
        }
})
  }

})

export const {
  initialiseDeviceSettings,
  setSettingsMic,
  setSettingsSpeaker,
  setSettingsCamera,
  setSettingsEffect,
  setSettingsBackground ,
  setDefaultBackgrounds ,
  setActiveTab
} = settingsSlice.actions




export default settingsSlice.reducer